import {Component, OnDestroy, OnInit} from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import { Subscription } from 'rxjs';
import { AccountService, EventManager } from 'src/app/core';
import { SessionStorageService } from 'ngx-webstorage';
import { MARKETING_USER_LEAD_ROUTES, MARKETING_USER_ROUTES } from './side-nav-routes.config';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-sidenav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss']
})

export class SideNavComponent implements OnInit, OnDestroy {
    public menuItems: any[];
    isFolded: boolean;
    isSideNavDark: boolean;
    subscriptions?: Subscription[] = [];
    total: number = 0;
    totalSupport: number = 0;
    url: string = 'link_route';
    selectedIndex : any = null;
    constructor( 
        private sessionStorageService: SessionStorageService,
        public eventManager: EventManager,
        private accountService: AccountService,
        private router: Router,
        private route: ActivatedRoute,
        private themeService: ThemeConstantService
    ) {}

    ngOnInit(): void {
        const accountInfo = this.accountService.getInfo() || {};
        const routers = MARKETING_USER_LEAD_ROUTES; //accountInfo.isMarketingLead ? MARKETING_USER_LEAD_ROUTES : MARKETING_USER_ROUTES;
        this.menuItems = routers.filter(menuItem => menuItem);
        this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
        this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
        this.total = this.sessionStorageService.retrieve('totalTransactions');
        this.subscriptions = [
            this.eventManager.subscribe('get-transactions', (res) => {
              this.total = res.content.total || [];
            }),
            this.eventManager.subscribe('get-support-list', (res) => {
                this.totalSupport = res.content.totalSupport || [];
            })
        ];
        this.url = this.route.snapshot['_routerState'].url;
        this.router.events.subscribe( (event) => {
            if (event instanceof NavigationEnd) {
               this.url = event.url || '';
               this.checkUrl(this.url);
            }
        });
        this.checkUrl(this.route.snapshot['_routerState'].url);
    }
    ngOnDestroy() {
        if (this.subscriptions.length > 0) {
          this.eventManager.destroys(this.subscriptions);
        }
    }
    checkUrl(url) {
        console.log('url', url);
        const split = (url || '').split('/');
        if (!split[0]) {
            split.shift();
        }
        const routes: any = {};
        split.forEach((route) => routes[route] = true);
        this.menuItems.forEach((menu) => {
            menu.selected = menu.path === '/' + split[0] || menu.path === split[0]; 
        })
    }
    checkActive(event, index) {
        this.selectedIndex = index;
        const item = this.menuItems[index];
        return item.submenu.length > 0 ? 'ant-menu-submenu-open' : 'ant-menu-item-selected'
    }
    test(index) {
        this.selectedIndex = this.selectedIndex !== index ? index : null;
    }
}
